import React, { Component } from 'react';
import {
    Card,
    CardContent,
    Typography,
    FormControl,
    Select,
    MenuItem,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import LaunchIcon from '@mui/icons-material/Launch';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CancelIcon from '@mui/icons-material/Cancel';
import { apiUrl } from '../../../../comp/ApiUrl';

class PaymentProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            provider: 'Mercado Pago',
            machines: [], // Corrigido para iniciar como array vazio
            isDialogOpen: false, // Controla a abertura do modal
            selectedMachine: '' // Guarda o ID da máquina selecionada
        };
    }

    handleChange = (event) => {
        this.setState({ provider: event.target.value });
    };

    // Manipulador para a seleção da máquina no Radio
    handleMachineChange = (event) => {
        this.setState({ selectedMachine: event.target.value });
    };

    // Abre/fecha o Dialog
    toggleDialog = () => {
        this.setState((prevState) => ({ isDialogOpen: !prevState.isDialogOpen }));
    };

    // Função que faz o POST para salvar a maquininha selecionada
    handleSaveMachine = () => {
        const { selectedMachine, machines } = this.state;

        if (!selectedMachine) {
            alert('Por favor, selecione uma maquininha antes de salvar.');
            return;
        }

        // Encontra o objeto completo da máquina selecionada, caso sua API precise de mais dados
        const machineData = machines.find(m => m.id === selectedMachine);

        fetch(`${apiUrl}/mercadopago/maquininhas/salvar`, { // Substitua pela sua rota real de POST
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                machineId: selectedMachine,
                ...machineData
            })
        })
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    alert('Maquininha salva com sucesso!');
                    this.toggleDialog(); // Fecha o modal
                } else {
                    alert('Erro ao salvar a maquininha.');
                }
            })
            .catch((error) => {
                console.error('Erro na requisição:', error);
                alert('Erro de conexão ao salvar.');
            });
    };

    render() {
        return (
            <Box>
                <Card sx={{ width: '100%', borderRadius: 3, boxShadow: '0px 2px 8px rgba(0,0,0,0.05)', border: '1px solid #e0e0e0' }}>
                    <CardContent sx={{ p: 4 }}>

                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333', mb: 1 }}>
                            Provedor de Pagamento
                        </Typography>

                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <Select
                                value={this.state.provider}
                                onChange={this.handleChange}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Provedor de Pagamento' }}
                                sx={{
                                    borderRadius: 2,
                                    bgcolor: '#fff',
                                    '& .MuiSelect-select': { py: 1.5 }
                                }}
                            >
                                <MenuItem value="Mercado Pago">Mercado Pago</MenuItem>
                            </Select>
                        </FormControl>

                        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
                            Escolha qual serviço processará seus pagamentos.
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            bgcolor: '#f0f7ff',
                            border: '1px solid #e1f0ff',
                            borderRadius: 2,
                            p: 2.5,
                            mb: 3
                        }}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: '#d0e7ff',
                                borderRadius: '50%',
                                p: 1.5,
                                color: '#1976d2'
                            }}>
                                <LinkIcon />
                            </Box>

                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                                    Conexão Oficial
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#1976d2', mt: 0.5 }}>
                                    Utilize o botão abaixo para conectar sua conta Mercado Pago de forma segura. Não é necessário copiar e colar chaves manualmente.
                                </Typography>
                            </Box>
                        </Box>


                        {this.props.paymentData.mp ? <>  <Button
                            variant="contained"

                            rel="noopener noreferrer"
                            startIcon={<CancelIcon sx={{ fontSize: '1.2rem !important' }} />}
                            sx={{
                                bgcolor: '#009EE3',
                                '&:hover': { bgcolor: '#0081BC' },
                                color: '#FFFFFF',
                                textTransform: 'none',
                                borderRadius: 2,
                                px: 3,
                                py: 1.2,
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                boxShadow: 'none',
                            }}
                        >
                            Desconectar do Mercado Pago

                        </Button></> : <>  <Button
                            variant="contained"
                            component="a"
                            href="https://api.fazpedido.com.br/auth/mercadopago/connect"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<LaunchIcon sx={{ fontSize: '1.2rem !important' }} />}
                            sx={{
                                bgcolor: '#009EE3',
                                '&:hover': { bgcolor: '#0081BC' },
                                color: '#FFFFFF',
                                textTransform: 'none',
                                borderRadius: 2,
                                px: 3,
                                py: 1.2,
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                boxShadow: 'none',
                            }}
                        >
                            Conectar com Mercado Pago

                        </Button></>}




                        {this.props.paymentData.mp && (


                            <>

                                {this.props.paymentData.c_machine ? <>


                                    <Button
                                        variant="contained"

                                        startIcon={<PointOfSaleIcon sx={{ fontSize: '1.2rem !important' }} />}
                                        sx={{
                                            bgcolor: '#FFF159',
                                            '&:hover': { bgcolor: '#E6D850' },
                                            color: '#111111',
                                            textTransform: 'none',
                                            borderRadius: 2,
                                            px: 3,
                                            py: 1.2,
                                            marginLeft: 2,
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        Desconectar Máquina de Cartão
                                    </Button>




                                </> : <Button
                                    variant="contained"
                                    onClick={() => {
                                        fetch(`${apiUrl}/mercadopago/maquininhas/`, {
                                            credentials: 'include',
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json',
                                            }
                                        }).then((response) => {
                                            if (response.status === 200) {
                                                response.json().then((data) => {
                                                    // Salva os dados e abre o Dialog automaticamente
                                                    this.setState({
                                                        machines: data,
                                                        isDialogOpen: true
                                                    });
                                                });
                                            }
                                        });
                                    }}
                                    startIcon={<PointOfSaleIcon sx={{ fontSize: '1.2rem !important' }} />}
                                    sx={{
                                        bgcolor: '#FFF159',
                                        '&:hover': { bgcolor: '#E6D850' },
                                        color: '#111111',
                                        textTransform: 'none',
                                        borderRadius: 2,
                                        px: 3,
                                        py: 1.2,
                                        marginLeft: 2,
                                        fontWeight: 600,
                                        fontSize: '0.95rem',
                                        boxShadow: 'none',
                                    }}
                                >
                                    Conectar Máquina de Cartão
                                </Button>}

                            </>

                        )}

                    </CardContent>
                </Card>

                {/* MODAL / DIALOG PARA SELEÇÃO DA MAQUININHA */}
                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.toggleDialog}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle sx={{ fontWeight: 600 }}>Selecionar Máquina de Cartão</DialogTitle>
                    <DialogContent dividers>
                        {this.state.machines.length === 0 ? (
                            <Typography variant="body2" sx={{ color: '#666' }}>
                                Nenhuma maquininha encontrada nesta conta.
                            </Typography>
                        ) : (
                            <FormControl component="fieldset" fullWidth>
                                <RadioGroup
                                    value={this.state.selectedMachine}
                                    onChange={this.handleMachineChange}
                                >
                                    {this.state.machines.map((machine) => (
                                        <FormControlLabel
                                            key={machine.id}
                                            value={machine.id}
                                            control={<Radio />}
                                            label={
                                                <Box sx={{ my: 0.5 }}>
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                        {machine.id.split('__')[0] || 'Maquininha'} {/* Tenta pegar o modelo (ex: PAX_Q92) */}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
                                                        Modo: {machine.operating_mode} | ID Loja: {machine.store_id}
                                                    </Typography>
                                                </Box>
                                            }
                                            sx={{
                                                border: '1px solid #e0e0e0',
                                                borderRadius: 2,
                                                m: '4px 0',
                                                p: 1,
                                                width: '100%',
                                                '&:hover': { bgcolor: '#f9f9f9' }
                                            }}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ p: 2.5 }}>
                        <Button onClick={this.toggleDialog} color="inherit" sx={{ textTransform: 'none' }}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={this.handleSaveMachine}
                            variant="contained"
                            color="primary"
                            disabled={!this.state.selectedMachine}
                            sx={{ textTransform: 'none', borderRadius: 2 }}
                        >
                            Salvar Vincular
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}

export default PaymentProviderConfig;